import React, { PropsWithChildren, useMemo } from 'react'
import useDeepCompareEffect from 'use-deep-compare-effect'
import MapMarkers from './MapMarkers'
import { determineMapIcon } from '../utils/utils'
import { useMap } from '../contexts/mapContext'
import { Pharmacy } from '../types/pharmacy'

const Map = ({ children, pharmacies, onClick, showPins }: PropsWithChildren<{ pharmacies: Pharmacy[] | undefined; onClick?: (id: string) => void; showPins?: boolean}>) => {
  const { fitToMarkers, mapInstance } = useMap()
  const pharmacyAddresses = useMemo(() => {
    const items = pharmacies?.map(({ id, address }) => ({ id, address })) ?? [];
    return items.filter(
      (x) =>
        x.address &&
        typeof x.address.latitude === 'number' &&
        typeof x.address.longitude === 'number'
    );
  }, [pharmacies])

  const markers = useMemo(
    () =>
      pharmacies?.map((pharmacy) => {

        return {
          id: pharmacy.id,
          lat: pharmacy.address?.latitude,
          long: pharmacy.address?.longitude,
          icon: determineMapIcon({
            pharmacy,
          }),
          text: pharmacy.name,
          onClick,
        }
      }) ?? [],

    [pharmacies, onClick],
  )

  useDeepCompareEffect(() => {
    if (mapInstance) {
      fitToMarkers(pharmacyAddresses)
    }
  }, [pharmacyAddresses, mapInstance])
  return (
    <React.Fragment>
      {showPins && <MapMarkers markers={markers} />}
      {children}
    </React.Fragment>
  )
}

export default Map
